const FreeSpace = () => <div className="free-space is-flex-grow-1"></div>

export default FreeSpace